"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.LayoutDesign=void 0;var i;(function(e){e.GridView="Grid View",e.ListView="List View"})(i||(exports.LayoutDesign=i={}));
//# sourceMappingURL=LayoutDesign.js.map
